import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { OHLCBlock } from '../../types/market.types';

// Initialize recoil-persist for chart atoms
const { persistAtom } = recoilPersist({
  key: 'recoil-persist-chart',
  storage: localStorage,
});

// Chart type persisted atom
export const ChartTypePersistedAtom = atom<Record<string, any>>({
  key: 'chartTypePersisted',
  default: {},
  effects_UNSTABLE: [persistAtom],
});

// Drawing atom for chart drawings (persisted)
export const drawingAtom = atom<any>({
  key: 'drawing',
  default: null,
  effects_UNSTABLE: [persistAtom],
});

// Market to resolution atom (persisted)
export const market2resolutionAtom = atom<Record<string, string> | null>({
  key: 'market2resolution',
  default: null,
  effects_UNSTABLE: [persistAtom],
});

// Indicator count atom
export const indicatorCountAtom = atom<number>({
  key: 'indicatorCount',
  default: 0,
});

export const currentPriceAtom = atom<(OHLCBlock & {
  value: number;
  // color: string;
  marketParam: string;
}) | null>({
  key: 'currentPrice',
  default: null,
});